// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "productpg/" + {"189":"page-mixAndMatch","404":"page-singleProduct","406":"deferred"}[chunkId] + "." + {"189":"a9923ac0d1f63cea076f","404":"0f95ee132e50d9a98825","406":"c36e1f7555ff6dd4ec6f"}[chunkId] + ".css";
};